<lib-dialog-layout>
    <ng-container title>
        <div class="d-flex justify-content-between">
            <h3>{{ data.Title }}</h3>
        </div>
    </ng-container>
    <ng-container content>
        @if (data.Text) {
            <lib-iframe data-clarity-mask="true" [src]="data.Text"></lib-iframe>
        }
    </ng-container>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                id="LibraryDialogSecondaryButton"
                [kind]="ButtonKind.Secondary"
                (clicked)="PrimaryAction()">
                <ng-container label>
                    {{ primaryButtonText }}
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
